export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImViNjJiZWExLTg0NzgtNDAwZi04ZDNhLTcyM2U2NTNhYmVlMCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.VHBJbkWpPO+bmzULQrFl63iAUZb0HYTarYtjJnmAs+F8OVwYV8KJw0Idz24a4p89ldOaJd4QjaS7HldnHSRMGBC6r5VdKGaWpGDvJNFkPVLxJyv4U6LjxE/BEVJ8BuUCchSUKw==";
